<template>
    <div>
        <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.privacy-section-7 class="text-left fw-500">7. Data Privacy and Confidentiality</b-button>
            </b-card-header>
            <b-collapse id="privacy-section-7" visible accordion="my-accordion" role="tabpanel">
                <b-card-body>
                    <ol>
                        <li>Privacy Policy: RCPAY Virtual Account collects and uses personal data in accordance with its Privacy Policy, available on the Platform's website.</li>
                        <li>Data Sharing: RCPAY Virtual Account will not disclose personal data to third parties without consent, except as required by law or as necessary to provide the VA service.</li>
                        <li>Data Security: RCPAY Virtual Account implements appropriate technical and organizational measures to protect personal data against unauthorized access, loss, or destruction.</li>
                    </ol>
                </b-card-body>
            </b-collapse>
        </b-card>
      
    </div>
</template>

<script>
  
export default {
    name: 'section-7',
    data() {
        return {
        publicPath      : process.env.BASE_URL!='/'?process.env.BASE_URL:''
        };
    }
};
</script>